'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _rpNavigation = require('rp-navigation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publicIndexes = function publicIndexes($, Responsive) {
    function more(Rp1Index) {
        var showMore = new Rp1Index($);

        var sizes = {
            '.sectionA__image': {
                extraNarrow: 'br-n',
                narrow: 'br-n',
                medium: 'br-n',
                wide: 'br-n',
                extraWide: 'br-n'
            },
            '.sectionB__image': {
                extraNarrow: 'br-n',
                narrow: 'br-xn',
                medium: 'br-xn',
                wide: 'br-xn',
                extraWide: 'br-xn'
            },
            '.sectionD__image': {
                extraNarrow: 'br-m',
                narrow: 'br-m',
                medium: 'br-w',
                wide: 'br-w',
                extraWide: 'br-w'
            },
            '.sectionI__image': {
                extraNarrow: 'br-n',
                narrow: 'br-xn',
                medium: 'br-xn',
                wide: 'br-n',
                extraWide: 'br-xn'
            }
        };
        var keys = (0, _keys2.default)(sizes);
        for (var key in keys) {
            var cls = keys[key];
            var res = new Responsive($(cls), $);
            res.config = sizes[cls];
            res.BreakPointListener();
        }

        showMore.init({
            indexId: $('.content').data('index'),
            sectionsUrl: $('.content').data('url'),
            sizes: sizes
        });
    }

    function startHashClickHandle(selector) {
        $('#secondaryNav').on('click', selector, function (e) {
            var target = $('#' + this.hash.substr(this.hash.lastIndexOf('#') + 1));
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                _rpNavigation.secondary._closeNarrow();
                return false;
            }
        });
    }

    return {
        showMoreDisplay: more,
        startHashClickHandle: startHashClickHandle
    };
};

exports.default = publicIndexes;


//////////////////
// WEBPACK FOOTER
// ./public/js/sections.js
// module id = 711
// module chunks = 0